import Glide from '@glidejs/glide';

export default function TextCarouselGlide() {
    let textCarouselWrapper = document.getElementById("header_text-carousel");
  
    if(textCarouselWrapper) {
      const textCarousel = new Glide(textCarouselWrapper, {
        type: 'carousel',
        autoplay: 4000,
        animationDuration: 200,
        startAt: 0,
        gap: 15,
        perView: 2,
      });
  
      textCarousel.mount();
    }
}